import React from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import excelImg from "../../Assets/images/excel.svg";
import { Link, useLocation } from "react-router-dom";
import { LanguageConstants } from "../../constants/LanguageConstants";

function RequestQuote2() {
    const { state } = useLocation();

  return (
    <>
    <main>
      <section
        className="main-banner small-banner"
        style={{ background: `url(${profileBanner}) center/cover` }}
      >
        <div className="container">
          <h1 className="small-banner-heading">{LanguageConstants?.REQUESTQUOTES}</h1>
        </div>
      </section>
      {/* top banner section end  */}

      <div className="footer-space">
          <div className="container">
              <h2 className="title-1 mb-2">{LanguageConstants?.BULK_REQUEST_TEXT}</h2>
              <p className="title-para">
                {LanguageConstants?.INCORRECT_TEXT}
              </p>
              <div className="incorrect-table-wrap">
                  <h2 className="title-1 mb-2">{LanguageConstants?.INCORRECT_DATA}</h2>
                  <div className="table-responsive incorrect-table">
                      <table className="table">
                          <thead>
                              <tr>
                                  <th>{LanguageConstants?.PARTNAME}</th>
                                  <th>{LanguageConstants?.BRAND}</th>
                                  <th>{LanguageConstants?.QUANTITY}</th>
                                  <th className="desc-column">{LanguageConstants?.Description}</th>
                              </tr>
                          </thead>
                          <tbody>
                            {state?.data?.map((res:any ,i:any)=>(
                                <tr key={i}>
                                  <td>{res?.part_number || 'N/A'}</td>
                                  <td>{res?.brand_id || 'N/A'}</td>
                                  <td>{res?.quantity || 'N/A'}</td>
                                  <td>{res?.description || 'N/A'}</td>
                              </tr>
                            ))}
                          </tbody>
                      </table>
                  </div>

                  <div className="form-btm-footer">
                      <div className="form-btm-col ms-auto">
                        <Link to='/my-quotation'>
                          <button className="round-btn round-btn-outline w-100">{LanguageConstants?.MYOUESTION}</button>
                        </Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </main>
  </>
  )
}

export default RequestQuote2